import React from 'react'
import './CTA.scss'
import PlaySymbol from '../../../assets/svg/play.inline.svg'
import VideoLink from '../../VideoLink/VideoLink'
import { Link } from 'gatsby'

const Cta = ({link, playSymbol, embed, embedActive, title}) => {
	if(embedActive) {
		return <div className="Cta"><div className="Cta-wrapper grid"><VideoLink text={title ? title : 'Se video'} embed={embed} /></div></div>
	}
	return(
		<div className="Cta">
			<div className="Cta-wrapper grid">
				<div className="link">
					{
						link &&
							(link.url.includes('http') || link.target)
							?
								<a href={link.url} target={link.target}>
									{	playSymbol && <PlaySymbol /> }
									<span>
										{link.title}
										<svg className="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.011 20.951">
											<g>
												<path d="M37.759,23.354l-7.88-7.88,2.6-2.6L42.95,23.354,32.475,33.83l-2.6-2.6Z" transform="translate(-18.94 -12.879)" fillRule="evenodd"/>
												<path d="M12,27H32.191v3.671H12Z" transform="translate(-12 -18.36)" />
											</g>
										</svg>
									</span>
								</a>
							:
								<Link to={link.url}>
									{	playSymbol && <PlaySymbol /> }
									<span>
										{link.title}
										<svg className="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.011 20.951">
											<g>
												<path d="M37.759,23.354l-7.88-7.88,2.6-2.6L42.95,23.354,32.475,33.83l-2.6-2.6Z" transform="translate(-18.94 -12.879)" fillRule="evenodd"/>
												<path d="M12,27H32.191v3.671H12Z" transform="translate(-12 -18.36)" />
											</g>
										</svg>
									</span>
								</Link>
					}
				</div>
			</div>
		</div>
	)
}

export default Cta